/**
 * @ngdoc directive
 * @name kpAddClassOnHover
 * @module portaro.directives
 *
 * @restrict A
 * @element ANY
 *
 * @param {expression} kpAddClassOnHover Class(es) to add
 *
 * @description
 * Directive supplies `:hover` behaviour. On mouse enter adds class(es), and on mouse leave removes them.
 * Directive supports inserting more classes, which have to be space separated.
 *
 * @example
 * <example module="kpAddClassOnHoverExample" name="kpAddClassOnHoverExample" frame-no-resize="true">
    <file name="index.html">
        <main>
            <div class="red" kp-add-class-on-hover="'blue'"></div>
        </main>
    </file>
    <file name="script.js">
        angular.module('kpAddClassOnHoverExample', ['portaro.directives']);
    </file>
    <file name="style.css">
        .red {
            width: 100px;
            height: 100px;

            background-color: red;
        }

        .blue {
            background-color: blue;
        }
    </file>
 * </example>
 */
export default class AddClassOnHoverDirective {
    static directiveName = 'kpAddClassOnHover';

    restrict = 'A';

    /*@ngInject*/
    constructor($parse) {
        this.$parse = $parse;
    }

    link($scope, $element, attrs) {
        const classToAdd = this.$parse(attrs[AddClassOnHoverDirective.directiveName])($scope);

        let hasClass = [];

        const mouseEnterHandler = () => {
            hasClass = classToAdd.split(' ').map((cssClass) => $element.hasClass(cssClass.trim()));

            $element.addClass(classToAdd);
        };
        const mouseLeaveHandler = () => {
            hasClass = classToAdd.split(' ').forEach((cssClass, i) => {
                if (hasClass && !hasClass[i]) {
                    $element.removeClass(cssClass.trim());
                }
            });
        };

        $element
            .on('mouseenter', mouseEnterHandler)
            .on('mouseleave', mouseLeaveHandler);

        $scope.$on('$destroy', () => {
            $element
                .off('mouseenter', mouseEnterHandler)
                .off('mouseleave', mouseLeaveHandler);
        });
    }
}